"use client"

import { usePathname, useSearchParams } from "next/navigation"
import { useEffect, useRef } from "react"
import { useCookieConsent } from "@modules/common/components/cookie-consent"
import { trackAbandonedCartActivity } from "../../lib/tracking"

export default function AbandonedCartTracker({
  cartId,
}: {
  cartId: string | null
}) {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const { consent } = useCookieConsent()
  const lastTracked = useRef("")

  useEffect(() => {
    if (!cartId) return

    const key = `${cartId}:${pathname}?${searchParams.toString()}:${
      consent?.analytics ?? false
    }:${consent?.marketing ?? false}`

    if (lastTracked.current === key) return
    lastTracked.current = key

    trackAbandonedCartActivity({ cartId, consent })
  }, [cartId, pathname, searchParams, consent])

  useEffect(() => {
    if (!cartId) return

    const interval = window.setInterval(() => {
      trackAbandonedCartActivity({ cartId, consent })
    }, 60_000)

    return () => window.clearInterval(interval)
  }, [cartId, consent])

  return null
}
